import Swiper from "swiper";
import { Pagination, Navigation } from "swiper/modules";
Swiper.use([Pagination, Navigation]);

(function () {
  const statementslider = document.querySelectorAll(".statement-slider");
  let statementSwiper = [];

  for (let i = 0; i < statementslider.length; i++) {
    statementSwiper[i] = new Swiper(statementslider[i], {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 15,
      // autoHeight: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 3,
      },
      // breakpoints: {
      //   // when window width is >= 320px
      //   920: {
      //     autoHeight: false,
      //   },
      // },
    });
  }
})();
